<template>
    <Transition>
        <Teleport to="#modals">
            <Modal
                v-show="active"
                :active="active"
                title="Reviews"
                @close="emits('close')"
            >
                <div class="space-y-4 sm:space-y-7 pt-4 sm:pt-7 border-t border-brand-2-950/10">
                    <slot />
                </div>
            </Modal>
        </Teleport>
    </Transition>
</template>

<script setup>
    import Modal from '@js/src/components/Modal.vue';

    const props = defineProps([
        'active',
    ]);

    const emits = defineEmits([
        'close',
    ]);
</script>
